import { render, staticRenderFns } from "./OrderSummary.vue?vue&type=template&id=3e9a1748&scoped=true"
import script from "./OrderSummary.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderSummary.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./OrderSummary.vue?vue&type=style&index=0&id=3e9a1748&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e9a1748",
  null
  
)

export default component.exports